import React from 'react';
import './App.scss';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import SignIn from "./component/pages/SignIn/SignIn";
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import {PagePermissionsProvider} from "./component/auth/PagePermissionsContext";
import NavigationConstants from "./enums/NavigationConstants";
import ExternalHome from "./component/pages/Home/ExternalHome";
import InternalHome from "./component/pages/Home/InternalHome";
import MyAccountPage from "./component/pages/SignIn/MyAccountPage";
import AdminLogin from "./component/admin/AdminLogin";
import AdminDashboard from "./component/admin/AdminDashboard";
import RequestDetails from "./component/admin/RequestDetails";
import RequestDashboard from "./component/pages/AppRequestFlow/RequestDashboard";
import SelfRegistration from './component/common/SelfRegistration';
import {ToastContainer} from "react-toastify";
import AssignRoles from './component/admin/AssignRoles';
import RequestHistory from "./component/admin/RequestHistory";
import ApiRedirect from "./component/common/ApiRedirect";
import UserManagement from "./component/admin/UserManagement";
import AdminEditAccount from "./component/admin/AdminEditAccount";
import InternalRequestDashboard from "./component/pages/AppRequestFlow/InternalRequestDashboard";
import ExternalRequestHistory from "./component/pages/ExternalRequestHistory/ExternalRequestHistory";
import InternalUserDetails from "./component/admin/InternalUserDetails";

type AppProps = {
    msalInstance: PublicClientApplication;
};

function App({msalInstance}: AppProps) {
    return (
        <MsalProvider instance={msalInstance}>
            <ToastContainer theme={"light"} autoClose={false} closeButton closeOnClick={false} hideProgressBar/>
            <PagePermissionsProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<SignIn/>}/>
                        <Route path={NavigationConstants.ExternalHome} element={<ExternalHome/>}></Route>
                        <Route path={NavigationConstants.InternalHome} element={<InternalHome/>}></Route>
                        <Route path="/my-account" element={<MyAccountPage/>}/>
                        <Route path="/admin-login" element={<AdminLogin/>}/>
                        <Route path="/admin-dashboard" element=<AdminDashboard/> />
                        <Route path="/request-dashboard" element=<RequestDashboard/> />
                        <Route path="/internal-request-dashboard" element=<InternalRequestDashboard/> />
                        <Route path="/external-request-history" element=<ExternalRequestHistory/> />
                        <Route path="/self-registration" element=<SelfRegistration/> />
                        <Route path="/assign-roles" element={<AssignRoles/>}/>
                        <Route path="/request-history" element={<RequestHistory/>}/>
                        <Route path="/request-details" element={<RequestDetails/>}/>
                        <Route path="/api-redirect" element={<ApiRedirect/>}/>
                        <Route path="/manage-user" element={<UserManagement/>}/>
                        <Route path="/admin/edit-account" element={<AdminEditAccount/>}/>
                        <Route path="/internal-user-details" element={<InternalUserDetails/>}/>
                    </Routes>
                </BrowserRouter>
            </PagePermissionsProvider>
        </MsalProvider>
    );
}

export default App;
